var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/Calendar.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var Calendar = function Calendar(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "39",
    height: "40",
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8 5.20001V2.60004H27.4C27.7448 2.60004 28.0754 2.46304 28.3192 2.21924C28.563 1.97544 28.7 1.64483 28.7 1.30005C28.7 0.955267 28.563 0.624596 28.3192 0.380798C28.0754 0.137001 27.7448 0 27.4 0H19.7C19.3552 0 19.0246 0.137001 18.7808 0.380798C18.537 0.624596 18.4 0.955267 18.4 1.30005C18.4 1.64483 18.537 1.97544 18.7808 2.21924C19.0246 2.46304 19.3552 2.60004 19.7 2.60004H22.29V5.20001C19.3035 5.44666 16.4534 6.55766 14.0878 8.39728C11.7222 10.2369 9.94352 12.7256 8.96889 15.5593C7.99426 18.3931 7.8659 21.4493 8.59947 24.3549C9.33304 27.2604 10.8968 29.8894 13.0998 31.9209C15.3028 33.9524 18.0497 35.2985 21.005 35.7947C23.9603 36.2909 26.9962 35.9158 29.7419 34.7152C32.4875 33.5146 34.8242 31.5405 36.4665 29.0339C38.1088 26.5273 38.9857 23.5967 38.99 20.6C38.9517 16.7316 37.4793 13.015 34.8578 10.17C32.2364 7.32497 28.6524 5.55399 24.8 5.20001ZM29.5 16.3L26.9 18.9C27.1381 19.4368 27.2738 20.0134 27.3 20.6C27.3 21.6344 26.8891 22.6263 26.1577 23.3577C25.4263 24.0891 24.4343 24.5 23.4 24.5C22.3657 24.5 21.3737 24.0891 20.6423 23.3577C19.9109 22.6263 19.5 21.6344 19.5 20.6C19.4777 20.0077 19.616 19.4203 19.9 18.9L14.8 13.8C14.5613 13.5614 14.4272 13.2376 14.4272 12.9C14.4272 12.5625 14.5613 12.2387 14.8 12C15.0387 11.7613 15.3624 11.6273 15.7 11.6273C16.0376 11.6273 16.3613 11.7613 16.6 12L21.7 17.1C22.2368 16.8619 22.8134 16.7262 23.4 16.7C23.9924 16.6778 24.5797 16.816 25.1 17.1L27.7 14.5C27.8182 14.3818 27.9585 14.2881 28.1129 14.2241C28.2673 14.1602 28.4329 14.1273 28.6 14.1273C28.7671 14.1273 28.9326 14.1602 29.0871 14.2241C29.2415 14.2881 29.3818 14.3818 29.5 14.5C29.6182 14.6182 29.7119 14.7585 29.7759 14.913C29.8399 15.0674 29.8728 15.2329 29.8728 15.4C29.8728 15.5672 29.8399 15.7327 29.7759 15.8871C29.7119 16.0415 29.6182 16.1819 29.5 16.3Z",
    fill: "#A6E5FF",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 21.9C23.7571 21.9 24.0085 21.8238 24.2222 21.681C24.436 21.5381 24.6026 21.3351 24.701 21.0976C24.7994 20.86 24.8252 20.5986 24.775 20.3465C24.7249 20.0943 24.6011 19.8626 24.4192 19.6808C24.2374 19.499 24.0058 19.3752 23.7536 19.325C23.5014 19.2749 23.2401 19.3006 23.0025 19.399C22.765 19.4974 22.5619 19.664 22.4191 19.8778C22.2762 20.0916 22.2 20.3429 22.2 20.6001C22.2 20.9448 22.337 21.2755 22.5808 21.5193C22.8246 21.7631 23.1552 21.9 23.5 21.9Z",
    fill: "#A6E5FF",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6 27.2C9.58845 27.3553 9.52152 27.5013 9.41141 27.6115C9.30129 27.7216 9.1553 27.7885 9 27.8H5.4C5.2447 27.7885 5.09871 27.7216 4.98859 27.6115C4.87848 27.5013 4.81155 27.3553 4.8 27.2V23.6C4.81155 23.4447 4.87848 23.2987 4.98859 23.1886C5.09871 23.0785 5.2447 23.0116 5.4 23H9C9.1553 23.0116 9.30129 23.0785 9.41141 23.1886C9.52152 23.2987 9.58845 23.4447 9.6 23.6V27.2Z",
    fill: "#F2A619",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2 27.2C24.1885 27.3553 24.1215 27.5013 24.0114 27.6115C23.9013 27.7216 23.7553 27.7885 23.6 27.8H19.9C19.7447 27.7885 19.5987 27.7216 19.4886 27.6115C19.3785 27.5013 19.3116 27.3553 19.3 27.2V23.6C19.3116 23.4447 19.3785 23.2987 19.4886 23.1886C19.5987 23.0785 19.7447 23.0116 19.9 23H23.5C23.6553 23.0116 23.8013 23.0785 23.9114 23.1886C24.0215 23.2987 24.0884 23.4447 24.1 23.6V27.2H24.2Z",
    fill: "#0D4599",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9 27.2C16.8885 27.3553 16.8215 27.5013 16.7114 27.6115C16.6013 27.7216 16.4553 27.7885 16.3 27.8H12.7C12.5447 27.7885 12.3987 27.7216 12.2886 27.6115C12.1785 27.5013 12.1115 27.3553 12.1 27.2V23.6C12.1115 23.4447 12.1785 23.2987 12.2886 23.1886C12.3987 23.0785 12.5447 23.0116 12.7 23H16.29C16.4453 23.0116 16.5913 23.0785 16.7014 23.1886C16.8115 23.2987 16.8784 23.4447 16.89 23.6L16.9 27.2Z",
    fill: "#F2A619",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6 34.53C9.58845 34.6853 9.52152 34.8313 9.41141 34.9414C9.30129 35.0515 9.1553 35.1184 9 35.1299H5.4C5.2447 35.1184 5.09871 35.0515 4.98859 34.9414C4.87848 34.8313 4.81155 34.6853 4.8 34.53V30.93C4.81155 30.7747 4.87848 30.6287 4.98859 30.5186C5.09871 30.4084 5.2447 30.3415 5.4 30.33H9C9.1553 30.3415 9.30129 30.4084 9.41141 30.5186C9.52152 30.6287 9.58845 30.7747 9.6 30.93V34.53Z",
    fill: "#0D4599",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2 34.53C24.1885 34.6853 24.1215 34.8313 24.0114 34.9414C23.9013 35.0515 23.7553 35.1184 23.6 35.1299H19.9C19.7447 35.1184 19.5987 35.0515 19.4886 34.9414C19.3785 34.8313 19.3116 34.6853 19.3 34.53V30.93C19.3116 30.7747 19.3785 30.6287 19.4886 30.5186C19.5987 30.4084 19.7447 30.3415 19.9 30.33H23.5C23.6553 30.3415 23.8013 30.4084 23.9114 30.5186C24.0215 30.6287 24.0884 30.7747 24.1 30.93V34.53H24.2Z",
    fill: "#0D4599",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9 34.53C16.8885 34.6853 16.8215 34.8313 16.7114 34.9414C16.6013 35.0515 16.4553 35.1184 16.3 35.1299H12.7C12.5447 35.1184 12.3987 35.0515 12.2886 34.9414C12.1785 34.8313 12.1115 34.6853 12.1 34.53V30.93C12.1115 30.7747 12.1785 30.6287 12.2886 30.5186C12.3987 30.4084 12.5447 30.3415 12.7 30.33H16.29C16.4453 30.3415 16.5913 30.4084 16.7014 30.5186C16.8115 30.6287 16.8784 30.7747 16.89 30.93L16.9 34.53Z",
    fill: "#0D4599",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4 9.60004H24.2V7.20001C24.2 6.88175 24.0736 6.57655 23.8485 6.3515C23.6235 6.12646 23.3183 6 23 6C22.6817 6 22.3765 6.12646 22.1515 6.3515C21.9264 6.57655 21.8 6.88175 21.8 7.20001V9.60004H7.2V7.20001C7.2 6.88175 7.07357 6.57655 6.84852 6.3515C6.62348 6.12646 6.31826 6 6 6C5.68174 6 5.37652 6.12646 5.15147 6.3515C4.92643 6.57655 4.8 6.88175 4.8 7.20001V9.60004H3.6C3.12687 9.59872 2.65815 9.69095 2.22078 9.8714C1.78341 10.0518 1.38603 10.3169 1.05147 10.6515C0.71692 10.986 0.451795 11.3834 0.271346 11.8208C0.0908963 12.2582 -0.00132104 12.7269 -1.29121e-06 13.2V36.3C-0.00132104 36.7732 0.0908963 37.2419 0.271346 37.6793C0.451795 38.1166 0.71692 38.514 1.05147 38.8486C1.38603 39.1831 1.78341 39.4482 2.22078 39.6287C2.65815 39.8091 3.12687 39.9013 3.6 39.9H25.5C25.9731 39.9013 26.4418 39.8091 26.8792 39.6287C27.3166 39.4482 27.714 39.1831 28.0485 38.8486C28.3831 38.514 28.6482 38.1166 28.8287 37.6793C29.0091 37.2419 29.1013 36.7732 29.1 36.3V13.3C29.0676 12.3291 28.6673 11.4066 27.9804 10.7197C27.2934 10.0327 26.371 9.63247 25.4 9.60004ZM3.5 12.1H4.7V14.53C4.7 14.8483 4.82643 15.1535 5.05147 15.3785C5.27652 15.6036 5.58174 15.73 5.9 15.73C6.21826 15.73 6.52348 15.6036 6.74853 15.3785C6.97357 15.1535 7.1 14.8483 7.1 14.53V12.13H21.7V14.53C21.7 14.8483 21.8264 15.1535 22.0515 15.3785C22.2765 15.6036 22.5817 15.73 22.9 15.73C23.2183 15.73 23.5235 15.6036 23.7485 15.3785C23.9736 15.1535 24.1 14.8483 24.1 14.53V12.13H25.29C25.4491 12.1244 25.6076 12.1516 25.7558 12.21C25.9039 12.2683 26.0384 12.3565 26.151 12.4691C26.2635 12.5816 26.3517 12.7161 26.41 12.8643C26.4684 13.0124 26.4956 13.1709 26.49 13.33V18.23H2.2V13.33C2.2352 13.004 2.38536 12.7011 2.62358 12.4757C2.8618 12.2503 3.1725 12.1172 3.5 12.1ZM25.4 37.6H3.5C3.34091 37.6056 3.18237 37.5784 3.03425 37.5201C2.88614 37.4618 2.75161 37.3736 2.63904 37.261C2.52648 37.1484 2.43829 37.0139 2.37996 36.8658C2.32163 36.7177 2.29441 36.5591 2.3 36.4V20.6H26.6V36.4C26.5948 36.7167 26.4668 37.0189 26.2428 37.2429C26.0189 37.4668 25.7167 37.5949 25.4 37.6Z",
    fill: "#0D4599",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement("defs", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: "39",
    height: "39.9",
    fill: "white",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 17
    }
  }))));
};

Calendar.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
Calendar.defaultProps = {
  className: null
};
export default Calendar;